var map = {
	"./action_image.png": 250,
	"./dimond.png": 251,
	"./logo_01.png": 56,
	"./logo_02.png": 93,
	"./logo_03.png": 94,
	"./logo_04.png": 57,
	"./logo_05.png": 58,
	"./p_feature1.png": 252,
	"./prototype_banner_img.png": 253,
	"./prototype_banner_img2.png": 254,
	"./psd.png": 255,
	"./saas.png": 256,
	"./tab.png": 257
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 249;